module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('ModalBase', {
    attrs: {
      "with-content": true
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.trads.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.trads.subhead.interpolate({
    width: _vm.data.width,
    height: _vm.data.height
  })))]), _vm._v(" "), _c('section', [(_vm.loading) ? _c('Spinner', {
    style: ({
      position: 'absolute'
    })
  }) : _vm._e(), _vm._v(" "), _c('ul', [_vm._l((_vm.columnsToGenerate), function(item, index) {
    return _c('li', {
      key: item.id || index
    }, [(item.type === 'ladder') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.id),
        expression: "item.id"
      }],
      attrs: {
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          item.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.ladders), function(ladder) {
      return _c('option', {
        key: ladder.id,
        domProps: {
          "value": ladder.id
        }
      }, [_vm._v(_vm._s(_vm.$tradFor(ladder.terms.name)))])
    })) : (item.type === 'empty') ? _c('NumberInput', {
      attrs: {
        "autofocus": true
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          item.value = $$v
        },
        expression: "item.value"
      }
    }) : (item.type === 'shelf') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.id),
        expression: "item.id"
      }],
      attrs: {
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          item.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.shelves), function(shelf) {
      return _c('option', {
        key: shelf.id,
        domProps: {
          "value": shelf.id
        }
      }, [_vm._v(_vm._s(_vm.$tradFor(shelf.terms.name)))])
    })) : _vm._e(), _vm._v(" "), (index > 0) ? _c('button', {
      on: {
        "click": function($event) {
          _vm.deleteAt(index);
        }
      }
    }, [_vm._v("delete")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.canAddLadders || _vm.canAddShelves || _vm.canAddSpace) ? _c('li', {
    staticClass: "add"
  }, [(_vm.canAddLadders) ? _c('select', {
    key: "ladder",
    on: {
      "input": _vm.addLadder
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Pick a ladder")]), _vm._v(" "), _vm._l((_vm.ladders), function(ladder) {
    return _c('option', {
      key: ladder.id,
      domProps: {
        "value": ladder.id
      }
    }, [_vm._v(_vm._s(_vm.$tradFor(ladder.terms.name)))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.canAddSpace) ? _c('button', {
    on: {
      "click": _vm.addSpace
    }
  }, [_vm._v("Add space")]) : _vm._e(), _vm._v(" "), (_vm.canAddShelves) ? _c('select', {
    key: "shelf",
    on: {
      "input": _vm.addShelf
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Pick a shelf")]), _vm._v(" "), _vm._l((_vm.shelves), function(shelf) {
    return _c('option', {
      key: shelf.id,
      domProps: {
        "value": shelf.id
      }
    }, [_vm._v(_vm._s(_vm.$tradFor(shelf.terms.name)))])
  })], 2) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.trads.generatedWidth.interpolate({
    width: _vm.generatedWidth
  })))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.trads.generatedHeight.interpolate({
    height: _vm.generatedHeight
  })))])])], 1), _vm._v(" "), _c('section', [_c('h4', [_vm._v(_vm._s(_vm.trads.paddingLabel))]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.trads.leftPadding))]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.padding.left),
      callback: function($$v) {
        _vm.padding.left = $$v
      },
      expression: "padding.left"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.trads.rightPadding))]), _vm._v(" "), _c('NumberInput', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.padding.right),
      callback: function($$v) {
        _vm.padding.right = $$v
      },
      expression: "padding.right"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.trads.topPadding))]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.padding.top),
      callback: function($$v) {
        _vm.padding.top = $$v
      },
      expression: "padding.top"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.trads.bottomPadding))]), _vm._v(" "), _c('NumberInput', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.padding.bottom),
      callback: function($$v) {
        _vm.padding.bottom = $$v
      },
      expression: "padding.bottom"
    }
  })], 1)]), _vm._v(" "), _c('footer', {
    staticStyle: {
      "float": "right",
      "margin-top": "5px"
    }
  }, [_c('ClientColorButton', {
    on: {
      "click": _vm.validate
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.ok))]), _vm._v(" "), _c('ClientColorButton', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31c30235","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/generate_ladders.vue
// module id = 3111
// module chunks = 0